import { defaultHttpClient } from '../../httpClient';
import type { GetRankingGoodsRequest, GetRankingGoodsResponse } from './types';

export const getRankingGoods = (params: GetRankingGoodsRequest) => {
  return defaultHttpClient
    .request<GetRankingGoodsResponse>({
      method: 'GET',
      url: '/api/v2/goods/',
      params,
    })
    .then(result => result.data);
};
